/**
 * @generated SignedSource<<3f298dbd11dd0b400043447c2430b6a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FilterMeetingOwnership = "ALL_MEETINGS" | "CUSTOM" | "ORGANIZED_BY_ME";
export type MeetingCopilotAutoRecordSettingsMutation$variables = {
  autoRecordEnabled: boolean;
  autoRecordOwnership: FilterMeetingOwnership;
};
export type MeetingCopilotAutoRecordSettingsMutation$data = {
  readonly updateUserAutoRecordSettings: {
    readonly settings: {
      readonly enabled: boolean;
      readonly id: string;
      readonly meetingOwnershipFilter: FilterMeetingOwnership;
    } | null;
  } | null;
};
export type MeetingCopilotAutoRecordSettingsMutation = {
  response: MeetingCopilotAutoRecordSettingsMutation$data;
  variables: MeetingCopilotAutoRecordSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "autoRecordEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "autoRecordOwnership"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "enabled",
        "variableName": "autoRecordEnabled"
      },
      {
        "kind": "Variable",
        "name": "meetingOwnershipFilter",
        "variableName": "autoRecordOwnership"
      }
    ],
    "concreteType": "UpdateUserAutoRecordSettings",
    "kind": "LinkedField",
    "name": "updateUserAutoRecordSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserAutoRecordSettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "meetingOwnershipFilter",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingCopilotAutoRecordSettingsMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MeetingCopilotAutoRecordSettingsMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "db9dc03b3098c9854002d548c3c640ec",
    "id": null,
    "metadata": {},
    "name": "MeetingCopilotAutoRecordSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation MeetingCopilotAutoRecordSettingsMutation(\n  $autoRecordOwnership: FilterMeetingOwnership!\n  $autoRecordEnabled: Boolean!\n) {\n  updateUserAutoRecordSettings(meetingOwnershipFilter: $autoRecordOwnership, enabled: $autoRecordEnabled) {\n    settings {\n      id\n      enabled\n      meetingOwnershipFilter\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6869ae9331b956afa7a067d03303f521";

export default node;
